import { getPublicAsset } from 'base/shared/Utils';

export const HOUSING_SECTION = {
  title: 'v2.home.housingSection.title',
  description: 'v2.home.housingSection.description',
  resources: [
    {
      id: 'shared_homes',
      image: getPublicAsset('v2/images/shared-homes.png'),
      title: 'v2.home.housingSection.sharedHomes.title',
      description: 'v2.home.housingSection.sharedHomes.description',
      search: {
        label: 'Barcelona--España',
        placeTypes: 1,
      },
    },
    {
      id: 'premium_homes',
      image: getPublicAsset('v2/images/premium-homes.png'),
      title: 'v2.home.housingSection.premiumHomes.title',
      description: 'v2.home.housingSection.premiumHomes.description',
      badge: 'v2.home.housingSection.premiumHomes.badge',
      link: '/s/Barcelona--España?et-search-source=search-bar&et-search-sorting=relevance&marketplaceSegmentBadiRooms=true',
    },
    {
      id: 'couples_accepted',
      image: getPublicAsset('v2/images/couples-accepted.png'),
      title: 'v2.home.housingSection.couplesAccepted.title',
      description: 'v2.home.housingSection.couplesAccepted.description',
      link: '/s/Barcelona--España?et-search-source=search-bar&et-search-sorting=relevance&amenities=13',
    },
    {
      id: 'pets_accepted',
      image: getPublicAsset('v2/images/pets-accepted.png'),
      title: 'v2.home.housingSection.petsAccepted.title',
      description: 'v2.home.housingSection.petsAccepted.description',
      link: '/s/Barcelona--España?et-search-source=search-bar&et-search-sorting=relevance&amenities=6',
    },
  ],
};
